import { Modal, ModalDialog, Stack, Textarea, Typography } from "@mui/joy";

function ModalLog(props) {

    var data = props.data

    var dataToPrint = "sem logs";

    if (typeof (data) == "string") {
        // data = JSON.parse(data)
        dataToPrint = "Data broken - non JSON \n"
        dataToPrint += data
    }

    // console.log(data != null)
    // console.log(data.logs != null)

    if (data != null && data.logs != null) {
        dataToPrint = "";

        data.logs.forEach(d => {
            dataToPrint += d + "\n"
        })
    }

    return <Modal open={props.isOpen} onClose={props.close}>
        <ModalDialog
            aria-labelledby="basic-modal-dialog-title"
            aria-describedby="basic-modal-dialog-description"
            sx={{ width: 750 }}
        >
            <Typography id="basic-modal-dialog-title" component="h2">
                Logs
            </Typography>

            {props.baixando && "Baixando"}
            {!props.baixando && data != null &&
                <Stack spacing={1}>
                    <Typography> <b>ID:</b> {data.id}</Typography>
                    <Typography> <b>Path:</b> {data.path}</Typography>
                    <Typography> <b>Inicio:</b> {data.inicio}</Typography>
                    <Typography> <b>Término:</b> {data.termino}</Typography>
                    <Typography> <b>Sucesso:</b> {data.sucesso ? "T" : "F"}</Typography>
                    <Typography> <b>Tempo Execução:</b> {data.tempoExecucao}</Typography>
                    <Textarea minRows={20} value={dataToPrint} maxRows={20} ></Textarea>
                </Stack>}
        </ModalDialog>
    </Modal>
}

export default ModalLog